import { FC, memo } from 'react';
import { twMerge } from 'tailwind-merge';

type ModalPatternCircleProps = {
  className?: string;
};

const ModalPatternCircleComp: FC<ModalPatternCircleProps> = ({ className }) => (
  <span className={twMerge('border border-secondary-border rounded-full size-24 absolute -left-6 -top-6', className)} />
);

export const ModalPatternCircle = memo(ModalPatternCircleComp);

ModalPatternCircle.displayName = 'ModalPatternCircle';
